import type { ReactNode } from "react";

/**
 * THE ITEM CARD - one pattern for findings and actions (UI review slice 3),
 * mirroring the Workbench's ItemCard (LINNFOSS UI framework). The ID and the
 * title read first, at item size and semibold; then one line of facts at meta
 * size and the state chip. Anything the item needs below that (controls,
 * history) is passed as children.
 */
export function ItemCard({
  id,
  title,
  tags,
  facts,
  state,
  note,
  children,
}: {
  /** The item's reference, e.g. F-12. */
  id: string;
  title: string;
  /** Small tags after the title: severity, origin. */
  tags?: ReactNode;
  /** One line of facts at meta size. */
  facts?: ReactNode;
  /** The state chip. */
  state?: ReactNode;
  /** A line of body text under the facts. */
  note?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <div className="item-card">
      <span className="item-card-head">
        <code className="item-card-id">{id}</code>
        <span className="item-card-title">{title}</span>
        {tags}
        {state}
      </span>
      {facts && <span className="item-card-facts">{facts}</span>}
      {note && <span className="item-card-note">{note}</span>}
      {children}
    </div>
  );
}
